const positionReadMoreButton = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const mediaTextBlocks = document.querySelectorAll(".media-text-content");

    mediaTextBlocks.forEach((block) => {
      const readMoreLink = block.querySelector(".media-text-read-more");
      const content = block.querySelector(".pattern__content");

      if (!readMoreLink || !content) {
        return;
      }

      content.innerHTML += readMoreLink.outerHTML;
      readMoreLink.remove();
    });
  });
};

export default positionReadMoreButton;
